/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { func, object, string } from 'prop-types';

import CancelSubscriptionDialog from '../Dialogs/CancelSubscriptionDialog';
import SkipSubscriptionDialog from '../Dialogs/SkipSubscriptionDialog';
import SkippedSubscriptionDialog from '../Dialogs/SkippedSubscriptionDialog';
import PauseSubscriptionDialog from '../Dialogs/PauseSubscriptionDialog';
import ResumeSubscriptionDialog from '../Dialogs/ResumeSubscriptionDialog';

const SubscriptionDialogContainer = ({
    activeModal,
    handleModal,
    handleUpdateSubscription,
    selectedRuleId,
    featureFlags,
    subscription,
}) => (
    <div>
        <CancelSubscriptionDialog
            handleModal={handleModal}
            handleCancel={handleUpdateSubscription}
            openModal={activeModal === 'Cancel'}
            selectedRuleId={selectedRuleId}
            featureFlags={featureFlags}
            subscription={subscription}
        />
        <SkipSubscriptionDialog
            handleModal={handleModal}
            handleUpdate={handleUpdateSubscription}
            openModal={activeModal === 'Skip'}
            selectedRuleId={selectedRuleId}
        />
        <SkippedSubscriptionDialog
            handleModal={handleModal}
            handleUpdate={handleUpdateSubscription}
            openModal={activeModal === 'Skipped'}
            selectedRuleId={selectedRuleId}
        />
        <PauseSubscriptionDialog
            handleModal={handleModal}
            handleUpdate={handleUpdateSubscription}
            openModal={activeModal === 'Pause'}
            selectedRuleId={selectedRuleId}
        />
        <ResumeSubscriptionDialog
            handleModal={handleModal}
            handleUpdate={handleUpdateSubscription}
            openModal={activeModal === 'Resume'}
            selectedRuleId={selectedRuleId}
        />
    </div>
);

SubscriptionDialogContainer.propTypes = {
    activeModal: string.isRequired,
    handleModal: func.isRequired,
    handleUpdateSubscription: func.isRequired,
    selectedRuleId: string.isRequired,
    featureFlags: object.isRequired,
    subscription: object.isRequired,
};

export default SubscriptionDialogContainer;
